export default __webpack_public_path__ + "static/media/anweshgangula.7c38650f.avif";